import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Header = Styled.header`
color:${color.primary};
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
text-align: center;
color: ${color.primary};
`;

const Heading = Styled.h2`
max-width: 20ch;
line-height: 1;
font-size: 4rem;
`;

const Paragraph = Styled.p`
max-width: 45ch;
margin-top: 2rem;
`;

const SectionHeader = ({ heading, paragraph }) => {
  return (
    <Header>
      <Heading>{heading}</Heading>
      <Paragraph>{paragraph}</Paragraph>
    </Header>
  );
};

export default SectionHeader;
